import { auth } from "@/lib/auth";
import { ChangePasswordForm } from "@/components/ChangePasswordForm";

export default async function DashboardParametresPage() {
  const session = await auth();

  return (
    <div className="space-y-6">
      <h1 className="text-lg font-bold text-[#07008b]">Paramètres du compte</h1>
      <div className="bg-white border border-slate-200 rounded-xl p-5">
        <p className="text-sm text-slate-400 mb-4">Connecté en tant que {session!.user.email}</p>
        <ChangePasswordForm />
      </div>
    </div>
  );
}
